(function () {
  if (customElements.get('ds-load-more')) return;

  class DsLoadMore extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';

      this.button = this.querySelector(
        '[data-load-more-button]'
      );

      this.status = this.querySelector(
        '[data-load-more-status]'
      );

      this.progress = this.querySelector(
        '[data-load-more-progress]'
      );

      this.completeMessage = this.querySelector(
        '[data-load-more-complete]'
      );

      this.loading = false;

      if (!this.button) return;

      this.button.addEventListener(
        'click',
        this.loadNextPage.bind(this)
      );

      this.updateProgress();
    }

    findProductGrid(scope) {
      if (!scope) return null;

      /*
        Coleções:
        <ul id="product-grid" class="product-grid">

        Busca:
        <div id="product-grid">
          <ul class="product-grid">
      */
      return (
        scope.querySelector(
          '#product-grid.product-grid'
        ) ||
        scope.querySelector(
          '#product-grid .product-grid'
        ) ||
        scope.querySelector('.product-grid')
      );
    }

    getSeen() {
      return Number(this.dataset.seen || 0);
    }

    getTotal() {
      return Number(this.dataset.total || 0);
    }

    updateProgress() {
      const seen = this.getSeen();
      const total = this.getTotal();

      const percentage = total
        ? Math.min(100, (seen / total) * 100)
        : 100;

      if (this.status) {
        this.status.textContent =
          'Você viu ' +
          seen +
          ' de ' +
          total +
          ' modelos';
      }

      if (this.progress) {
        this.progress.style.width =
          percentage + '%';
      }
    }

    setLoading(isLoading) {
      this.loading = isLoading;

      if (!this.button) return;

      this.button.disabled = isLoading;
      this.button.setAttribute(
        'aria-busy',
        isLoading ? 'true' : 'false'
      );

      this.classList.toggle(
        'is-loading',
        isLoading
      );
    }
finish() {
  this.dataset.nextUrl = '';
  this.classList.add('is-complete');

  if (this.button) {
    this.button.hidden = true;
    this.button.setAttribute('hidden', '');

    /*
      Força o desaparecimento mesmo que o CSS
      tenha display com !important.
    */
    this.button.style.setProperty(
      'display',
      'none',
      'important'
    );
  }

  if (this.completeMessage) {
    this.completeMessage.hidden = false;
    this.completeMessage.removeAttribute('hidden');
  }

  this.dataset.seen = String(
    this.getTotal()
  );

  this.updateProgress();
}

    async loadNextPage() {
      const nextUrl = this.dataset.nextUrl;

      if (this.loading || !nextUrl) return;

      this.setLoading(true);

      try {
        const response = await fetch(nextUrl, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(
            'Não foi possível carregar a próxima página.'
          );
        }

        const responseText =
          await response.text();

        const parsedDocument =
          new DOMParser().parseFromString(
            responseText,
            'text/html'
          );

        const incomingContainer =
          parsedDocument.querySelector(
            '#ProductGridContainer'
          );

        const currentContainer =
          this.closest('#ProductGridContainer') ||
          document.querySelector(
            '#ProductGridContainer'
          );

        const incomingGrid =
          this.findProductGrid(
            incomingContainer ||
            parsedDocument
          );

        const currentGrid =
          this.findProductGrid(
            currentContainer ||
            document
          );

        if (!incomingGrid || !currentGrid) {
          throw new Error(
            'A grade de produtos não foi encontrada.'
          );
        }

        const incomingItems = Array.from(
          incomingGrid.children
        ).filter(function (item) {
          return item.matches(
            'li.grid__item, .grid__item'
          );
        });

        if (!incomingItems.length) {
          this.finish();
          return;
        }

        const fragment =
          document.createDocumentFragment();

        incomingItems.forEach(function (item) {
          /*
            Evita que os cards carregados fiquem
            invisíveis esperando o observer do Dawn.
          */
          item.classList.remove(
            'scroll-trigger',
            'animate--slide-in'
          );

          item.removeAttribute('data-cascade');

          item.style.removeProperty(
            '--animation-order'
          );

          fragment.appendChild(item);
        });

        currentGrid.appendChild(fragment);

        const incomingLoadMore =
          incomingContainer
            ? incomingContainer.querySelector(
                'ds-load-more'
              )
            : parsedDocument.querySelector(
                'ds-load-more'
              );

        const currentSeen =
          this.getSeen();

        const total =
          this.getTotal();

        const nextSeen =
          incomingLoadMore
            ? Number(
                incomingLoadMore.dataset.seen ||
                currentSeen +
                  incomingItems.length
              )
            : Math.min(
                total,
                currentSeen +
                  incomingItems.length
              );

        this.dataset.seen =
          String(nextSeen);

        if (
          incomingLoadMore &&
          incomingLoadMore.dataset.nextUrl
        ) {
          this.dataset.nextUrl =
            incomingLoadMore.dataset.nextUrl;
        } else {
          this.finish();
        }

        this.updateProgress();

        /*
          Atualiza os corações dos favoritos
          nos cards recém-carregados.
        */
        window.dispatchEvent(
          new CustomEvent(
            'ds:favorites:updated'
          )
        );

        document.dispatchEvent(
          new CustomEvent(
            'ds:products:appended',
            {
              detail: {
                items: incomingItems,
                grid: currentGrid
              }
            }
          )
        );
      } catch (error) {
        console.error(
          '[Drip Load More]',
          error
        );

        const label =
          this.button &&
          this.button.querySelector(
            '.ds-load-more__button-label'
          );

        if (label) {
          label.textContent =
            'Tentar novamente';

          window.setTimeout(function () {
            label.textContent = 'Ver mais';
          }, 2200);
        }
      } finally {
        this.setLoading(false);
      }
    }
  }

  customElements.define(
    'ds-load-more',
    DsLoadMore
  );
})();